/**
* @file 资源管理-form-添加车辆
* */
<template>
  <div id="vehicleForm">
    <div name="formII">
      <el-row type="flex" align="middle" justify="space-between">
        <el-col :span="22">
          <div class="formTitle">车务信息</div>
        </el-col>
        <el-col :span="2" style="text-align: right">
          <el-button type="primary" :loading="loadingII" v-show="!editII"
                     @click="formEdit(true, 'formII', 'editII', 'temporaryFormII')">
            编辑
          </el-button>
        </el-col>
      </el-row>

      <div class="blueInfo">
        <p>* 如已开通监管对接服务，则信息必填</p>
        <p>* 车辆所有人应与《机动车登记证书》所注明的车辆所有人一致</p>
      </div>

      <el-form :model="formII" :rules="rulesII" ref="formII" :disabled="!editII" label-position="left"
               label-width="150px">
        <el-row>
          <el-col :span="11">
            <el-form-item label="车辆品牌" prop="brand">
              <el-input v-model="formII.brand" maxlength="64"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11" :push="2">
            <el-form-item label="发动机排量" prop="engineDisplace" :class="!editII ? 'white' : ''">
              <el-input v-model="formII.engineDisplace" maxlength="5" style="width: 275px"
                        oninput="value=value.replace(/[^\d]/g,'')">
              </el-input>
              <strong style="display: inline-block; width: 45px; text-align: right">毫升</strong>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="车辆类型" prop="vehicleType">
              <el-input v-model="formII.vehicleType" maxlength="64"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11" :push="2">
            <el-form-item label="车辆所有人" prop="ownerName">
              <el-input v-model="formII.ownerName" maxlength="64"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="注册日期" prop="certifyDateA">
              <el-date-picker v-model="formII.certifyDateA" size="mini" type="date">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="11" :push="2">
            <el-form-item label="核定载客位" prop="seats">
              <el-input v-model="formII.seats" maxlength="10" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="发动机号" prop="engineId">
              <el-input v-model="formII.engineId" maxlength="32"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11" :push="2">
            <el-form-item label="车辆检修状态" prop="fixState">
              <el-select v-model="formII.fixState">
                <el-option label="已检修" :value="0"></el-option>
                <el-option label="未检修" :value="1"></el-option>
                <el-option label="未知" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="车辆VIN码" prop="vin">
              <el-input v-model="formII.vin" maxlength="17"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11" :push="2">
            <el-form-item label="车辆初次登记日期" prop="certifyDateB">
              <el-date-picker v-model="formII.certifyDateB" size="mini" type="date">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="车辆轴距" prop="wheelBase">
              <el-input v-model="formII.wheelBase" maxlength="32"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11" :push="2">
            <el-form-item label="车辆运输证有效期起" prop="transDateStart">
              <el-date-picker v-model="formII.transDateStart" size="mini" type="date">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="燃料类型" prop="fuelType">
              <el-select v-model="formII.fuelType" filterable>
                <el-option label="汽油" value="A"></el-option>
                <el-option label="柴油" value="B"></el-option>
                <el-option label="电动" value="C"></el-option>
                <el-option label="天然气" value="E"></el-option>
                <el-option label="液化气" value="F"></el-option>
                <el-option label="其他" value="Z"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11" :push="2">
            <el-form-item label="车辆运输证有效期止" prop="transDateStop">
              <el-date-picker v-model="formII.transDateStop" size="mini" type="date">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="车辆运输证号" prop="certificate">
              <el-input v-model="formII.certificate" maxlength="128"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11" :push="2">
            <el-form-item label="车辆运输证发证机构" prop="transAgency">
              <el-input v-model="formII.transAgency" maxlength="256"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row style="text-align: right">
          <el-button v-show="editII" type="primary" @click="formSave('formII')" :loading="loadingII">
            保存
          </el-button>
          <el-button v-show="editII" @click="formEdit(false, 'formII', 'editII', 'temporaryFormII')"
                     :loading="loadingII">
            取消
          </el-button>
        </el-row>
      </el-form>
    </div>

    <div name="formIII">
      <el-row type="flex" align="middle" justify="space-between">
        <el-col :span="22">
          <div class="formTitle">其他信息</div>
        </el-col>
        <el-col :span="2" style="text-align: right">
          <el-button type="primary" :loading="loadingIII" v-show="!editIII"
                     @click="formEdit(true, 'formIII', 'editIII', 'temporaryFormIII')">
            编辑
          </el-button>
        </el-col>
      </el-row>

      <div class="blueInfo">
        <p>* 如已开通监管对接服务，则信息必填</p>
        <p>* 报备日期：车辆向服务所在地出租汽车行政主管部门报备时间</p>
      </div>

      <el-form :model="formIII" :rules="rulesIII" ref="formIII" :disabled="!editIII" label-position="left"
               label-width="150px">
        <el-row>
          <el-col :span="11">
            <el-form-item label="报备日期" prop="registerDate">
              <el-date-picker v-model="formIII.registerDate" size="mini" type="date">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="11" :push="2">
            <el-form-item label="发票打印设备序列号" prop="invoicePrinterSeries">
              <el-input v-model="formIII.invoicePrinterSeries" maxlength="32"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="服务类型" prop="commercialType">
              <el-select v-model="formIII.commercialType">
                <el-option label="网络预约出租汽车" :value="1"></el-option>
                <el-option label="巡游出租汽车" :value="2"></el-option>
                <el-option label="私人小客车合乘" :value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11" :push="2">
            <el-form-item label="卫星定位装置型号" prop="satellitePositioningModel">
              <el-input v-model="formIII.satellitePositioningModel" maxlength="64"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="车辆技术情况" prop="vehicleTec">
              <el-input v-model="formIII.vehicleTec" maxlength="32"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11" :push="2">
            <el-form-item label="卫星定位装置IMEI号" prop="gpsImei">
              <el-input v-model="formIII.gpsImei" maxlength="128"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="安全性能情况" prop="vehicleSafe">
              <el-input v-model="formIII.vehicleSafe" maxlength="32"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11" :push="2">
            <el-form-item label="卫星定位设备安装日期" prop="satellitePositioningDate">
              <el-date-picker v-model="formIII.satellitePositioningDate" size="mini" type="date">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="车辆下次年检时间" prop="nextFixDate">
              <el-date-picker v-model="formIII.nextFixDate" size="mini" type="date">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="11" :push="2">
            <el-form-item label="卫星定位装置品牌" prop="satellitePositioningBrand">
              <el-input v-model="formIII.satellitePositioningBrand" maxlength="256"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="车辆年度审验状态" prop="checkState">
              <el-select v-model="formIII.checkState">
                <el-option label="未年检" :value="0"></el-option>
                <el-option label="已年检" :value="1"></el-option>
                <el-option label="不合格" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11" :push="2">
            <el-form-item label="车辆经营区域" prop="transArea">
              <el-input v-model="formIII.transArea" maxlength="256"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row style="text-align: right">
          <el-button v-show="editIII" type="primary" @click="formSave('formIII')" :loading="loadingIII">
            保存
          </el-button>
          <el-button v-show="editIII" @click="formEdit(false, 'formIII', 'editIII', 'temporaryFormIII')"
                     :loading="loadingIII">
            取消
          </el-button>
        </el-row>
      </el-form>
    </div>

    <div name="Insurance">
      <!-- 模态框 -->
      <el-dialog :visible.sync="insuranceVisible" @close="resetField" width="26%">
        <el-row type="flex" align="middle">
          <el-col :span="22">
            <div class="formTitle" style="margin: 0 0 20px">保险信息</div>
          </el-col>
        </el-row>

        <el-form :model="formInsurance" :rules="rulesInsurance" ref="formInsurance" label-position="left"
                 label-width="120px">
          <el-form-item label="保险公司名称" prop="insuranceCompanyName">
            <el-input v-model="formInsurance.insuranceCompanyName" maxlength="64">
            </el-input>
          </el-form-item>
          <el-form-item label="保险号" prop="insuranceNo" class="white">
            <el-input v-model="formInsurance.insuranceNo" maxlength="64">
            </el-input>
          </el-form-item>
          <el-form-item label="类型" prop="insuranceType">
            <el-select v-model="formInsurance.insuranceType">
              <el-option label="交强险" :value="1"></el-option>
              <el-option label="商业险" :value="2"></el-option>
              <el-option label="承运人责任险" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="金额" prop="insuranceMoney">
            <el-input v-model="formInsurance.insuranceMoney" maxlength="9" style="width: 88%"
                      oninput="value=value.replace(/^\D*([1-9]\d*\.?\d{0,2})?.*$/,'$1')">
            </el-input>
            <strong style="display: inline-block; width: 12%; text-align: right">元</strong>
          </el-form-item>
          <el-form-item label="生效时间" prop="insuranceEffectTime">
            <el-date-picker v-model="formInsurance.insuranceEffectTime" size="mini" type="date">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="到期时间" prop="insuranceDueTime">
            <el-date-picker v-model="formInsurance.insuranceDueTime" size="mini" type="date">
            </el-date-picker>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" style="
            text-align: center;
            padding-top: 0;
            position: relative;
            top: -15px;
          ">
          <el-button type="primary" :loading="loadingInsurance" @click="formSave('formInsurance')">
            保存
          </el-button>
        </div>
      </el-dialog>

      <el-row>
        <el-col :span="22">
          <div class="formTitle">
            保险信息
            <!-- <span style="color: #999999; font-size: 1px; font-weight: 100">
              如已开通监管对接服务，则信息必填</span> -->
          </div>
        </el-col>
      </el-row>
      <div class="blueInfo">
        <p>* 如已开通监管对接服务，则信息必填</p>
      </div>
      <el-table style="margin-bottom: 20px" border empty-text="暂无数据" v-loading="loadingInsurance"
                :data="insuranceRows">
        <el-table-column v-for="(item, index) in insuranceColumns" :key="index" :show-overflow-tooltip="true"
                         :prop="item.prop" :label="item.label">
        </el-table-column>

        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)" type="text" size="small">编辑
            </el-button>
            <el-button type="text" size="small" @click="removeInsurance(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-button style="
          border: 1px #dcdfe6 dashed;
          margin-bottom: 40px;
          padding: 10px;
          width: 100%;
        " @click="insuranceAdd">添加保险信息
      </el-button>
      <br/><br/>
    </div>
  </div>
</template>

<script>
export default {
  name: "vehicleForm",
  data() {
    let insuranceValidatorStar = (rule, value, callback) => {

      let insuranceDueTime = Date.parse(
          new Date(this.formInsurance.insuranceDueTime)
      );
      value = Date.parse(new Date(value));
      if (!value) {
        callback(new Error("生效时间不能为空"));
      } else if (insuranceDueTime && insuranceDueTime <= value) {
        callback(new Error("不能大于或等于到期时间"));
      } else {
        callback();
      }
    };
    let insuranceValidatorEnd = (rule, value, callback) => {

      let insuranceEffectTime = Date.parse(
          new Date(this.formInsurance.insuranceEffectTime)
      );
      value = Date.parse(new Date(value));
      if (!value) {
        callback(new Error("到期时间不能为空"));
      } else if (insuranceEffectTime && value <= insuranceEffectTime) {
        callback(new Error("不能小于或等于生效时间"));
      } else {
        callback();
      }
    };

    let transValidatorStar = (rule, value, callback) => {
      let transDateStop = Date.parse(new Date(this.formII.transDateStop));
      value = Date.parse(new Date(value));
      if (!value) {
        callback(new Error("生效时间不能为空"));
      } else if (transDateStop && transDateStop <= value) {
        callback(new Error("不能大于或等于到期时间"));
      } else {
        callback();
      }
    };
    let transValidatorStop = (rule, value, callback) => {
      let transDateStart = Date.parse(new Date(this.formII.transDateStart));
      value = Date.parse(new Date(value));
      if (!value) {
        callback(new Error("失效时间不能为空"));
      } else if (transDateStart && value <= transDateStart) {
        callback(new Error("不能小于或等于有效时间"));
      } else {
        callback();
      }
    };

    let vinValidator = (rule, value, callback) => {
      var regu = /^[A-HJ-NPR-Z\d]{17}$/;
      var re = new RegExp(regu);
      if (!value) {
        callback(new Error("请输入车辆VIN码"));
      } else if (!re.test(value)) {
        callback(new Error("请输入正确的车辆VIN码"));
      } else {
        callback();
      }
    };
    return {
      id: this.$route.query.id,
      // 车务信息表单
      editII: false,
      temporaryFormII: null,
      formII: {
        brand: null,
        engineDisplace: null,
        vehicleType: null,
        ownerName: null,
        certifyDateA: null,
        seats: null,
        engineId: null,
        fixState: null,
        vin: null,
        certifyDateB: null,
        wheelBase: null,
        transDateStart: null,
        fuelType: null,
        transDateStop: null,
        certificate: null,
        transAgency: null,
      },
      rulesII: {
        brand: [{required: true, message: "请输入车辆品牌"}],
        engineDisplace: [{required: true, message: "请输入发动机排量"}],
        vehicleType: [{required: true, message: "请输入车辆类型"}],
        ownerName: [{required: true, message: "请输入车辆所有人"}],
        certifyDateA: [{required: true, message: "请选择注册日期"}],
        seats: [{required: true, message: "请输入核定载客位"}],
        engineId: [{required: true, message: "请输入发动机号"}],
        fixState: [{required: true, message: "请选择车辆检修状态"}],
        vin: [
          {
            required: true,
            validator: vinValidator,
          },
        ],
        certifyDateB: [{required: true, message: "请选择车辆初次登记日期"}],
        wheelBase: [{required: true, message: "请输入车辆轴距"}],
        transDateStart: [
          {
            required: true,
            validator: transValidatorStar,
          },
        ],
        fuelType: [{required: true, message: "请选择燃料类型"}],
        transDateStop: [
          {
            required: true,
            validator: transValidatorStop,
          },
        ],
        certificate: [{required: true, message: "请输入车辆运输证号"}],
        transAgency: [{required: true, message: "请输入车辆运输证发证机构"}],
      },

      // 其他信息表单
      editIII: false,
      temporaryFormIII: null,
      formIII: {
        registerDate: null,
        invoicePrinterSeries: null,
        commercialType: null,
        satellitePositioningModel: null,
        vehicleTec: null,
        gpsImei: null,
        vehicleSafe: null,
        satellitePositioningDate: null,
        nextFixDate: null,
        satellitePositioningBrand: null,
        checkState: null,
        transArea: null,
      },
      rulesIII: {
        registerDate: [{required: true, message: "请选择报备日期"}],
        invoicePrinterSeries: [
          {required: true, message: "请输入发票打印设备序列号"},
        ],
        commercialType: [{required: true, message: "请选择服务类型"}],
        satellitePositioningModel: [
          {required: true, message: "请输入卫星定位装置型号"},
        ],
        vehicleTec: [{required: true, message: "请输入车辆技术情况"}],
        gpsImei: [{required: true, message: "请输入卫星定位装置IMEI号"}],
        vehicleSafe: [{required: true, message: "请输入安全性能情况"}],
        satellitePositioningDate: [
          {required: true, message: "请选择卫星定位设备安装日期"},
        ],
        nextFixDate: [{required: true, message: "请选择车辆下次年检时间"}],
        satellitePositioningBrand: [
          {required: true, message: "请输入卫星定位装置品牌"},
        ],
        checkState: [{required: true, message: "请选择车辆年度审验状态"}],
        transArea: [{required: true, message: "请输入车辆经营区域"}],
      },

      // 保险信息
      insuranceVisible: false,
      formInsurance: {
        insuranceCompanyName: null,
        insuranceNo: null,
        insuranceType: null,
        insuranceMoney: null,
        insuranceEffectTime: null,
        insuranceDueTime: null,
      },
      rulesInsurance: {
        insuranceCompanyName: [
          {required: true, message: "请输入保险公司名称"},
        ],
        insuranceNo: [{required: true, message: "请输入保险号"}],
        insuranceType: [{required: true, message: "请选择类型"}],
        insuranceMoney: [{required: true, message: "请输入金额"}],
        insuranceEffectTime: [
          {
            required: true,
            validator: insuranceValidatorStar,
          },
        ],
        insuranceDueTime: [
          {
            required: true,
            validator: insuranceValidatorEnd,
          },
        ],
      },
      insuranceColumns: [
        {prop: "insuranceCompanyName", label: "保险公司名称"},
        {prop: "insuranceNo", label: "保险号"},
        {prop: "insuranceTypeName", label: "类型"},
        {prop: "insuranceMoney", label: "金额"},
        {prop: "insuranceEffectTime", label: "生效时间"},
        {prop: "insuranceDueTime", label: "到期时间"},
      ],
      insuranceRows: [],
      // 保存按钮loading
      loadingI: false,
      loadingII: false,
      loadingIII: false,
      loadingIIII: false,

      loadingInsurance: false,
      editIIII: false,
      formIIII: {
        compulsoryTrafficInsurance: '',
        commercialInsurance: '',
      },
      rulesIIII: {}
    };
  },

  methods: {
    // type:编辑或者取消 formName:表单form editNumber:编辑下标 temporaryForm:临时form对象
    formEdit(type, formName, editNumber, temporaryForm) {
      if (editNumber != "editI" && !this.id) {
        this.$message.warning("请先完善【基本信息】并保存后，再进行操作");
        return;
      }
      if (type) {
        this[temporaryForm] = JSON.parse(JSON.stringify(this[formName]));
        this[editNumber] = true;
      } else {
        this.$refs[formName].resetFields();
        this[formName] = JSON.parse(JSON.stringify(this[temporaryForm]));
        this[editNumber] = false;
      }
    },
    resetField() {
      this.formInsurance = {
        insuranceCompanyName: null,
        insuranceNo: null,
        insuranceType: null,
        insuranceMoney: null,
        insuranceEffectTime: null,
        insuranceDueTime: null,
      }
      this.$refs.formInsurance.resetFields();
    },
    // 添加保险信息事件
    insuranceAdd() {
      if (!this.id) {
        this.$message.warning("请先完善【基本信息】并保存后，再进行操作");
      } else {
        this.insuranceVisible = true;
      }
    },
    /**
     * 点击保存
     */
    async formSave(formName) {
      switch (formName) {
       
        case "formII":
          this.$refs.formII.validate((valid) => {
            if (valid) {
              this.postService();
            } else {
              this.$message.warning("请检查表单数据是否输入正确！");
            }
          });

          break;
        case "formIII":
          this.$refs.formIII.validate((valid) => {
            if (valid) {
              this.postOther();
            } else {
              this.$message.warning("请检查表单数据是否输入正确！");
            }
          });

          break;
        case "formInsurance":
          this.$refs.formInsurance.validate((valid) => {
            if (valid) {
              if (this.formInsurance.id) {
                this.putInsurance();
              } else {
                this.postInsurance();
              }
            } else {
              this.$message.warning("请检查表单数据是否输入正确！");
            }
          });

          break;
        case "formIIII":
          this.$refs.formIIII.validate((valid) => {
            if (valid) {
              this.postFormIIII();
            } else {
              this.$message.warning("请检查表单数据是否输入正确！");
            }
          });

          break;
        default:
          break;
      }
    },
    async postFormIIII() {
      this.loadingIIII = true;
      let url = "/api/v1/manage/vehicle/insurance";
      let data = await this.$axios.put(url, {...this.formIIII,});
      if (data && data.code === 1) {
        this.$message.success("保存成功！");
        this.editIIII = false;
      }
      this.loadingIIII = false;
    },
    /**
     * 接口请求-车务信息保存
     */
    async postService() {
      this.loadingII = true;
      let url = "/api/v1/manage/vehicle/supervise/service";
      let params = this.$utils.deepCopyFn({
        ...this.formII,
        certifyDateA: Date.parse(new Date(this.formII.certifyDateA)),
        certifyDateB: Date.parse(new Date(this.formII.certifyDateB)),
        transDateStart: Date.parse(new Date(this.formII.transDateStart)),
        transDateStop: Date.parse(new Date(this.formII.transDateStop)),
        vehicleId: this.id,
      });
      let data = await this.$axios.post(url, params);
      if (data && data.code === 1) {
        this.$message.success("保存成功！");
        this.formII.id = data.data;
        this.editII = false;
      }
      this.loadingII = false;
    },
    /**
     * 接口请求-其他信息保存
     */
    async postOther() {
      this.loadingIII = true;
      let url = "/api/v1/manage/vehicle/supervise/other";
      let params = this.$utils.deepCopyFn({
        ...this.formIII,
        registerDate: Date.parse(new Date(this.formIII.registerDate)),
        nextFixDate: Date.parse(new Date(this.formIII.nextFixDate)),
        satellitePositioningDate: Date.parse(
            new Date(this.formIII.satellitePositioningDate)
        ),
        vehicleId: this.id,
      });
      let data = await this.$axios.post(url, params);
      if (data && data.code === 1) {
        this.$message.success("保存成功！");
        this.formIII.id = data.data;
        this.editIII = false;
      }
      this.loadingIII = false;
    },
    /**
     * 接口请求-保险信息新增
     */
    async postInsurance() {
      this.loadingInsurance = true;
      let url = "/api/v1/manage/vehicle/supervise/insurance";
      let params = this.$utils.deepCopyFn({
        ...this.formInsurance,
        insuranceEffectTime: Date.parse(
            new Date(this.formInsurance.insuranceEffectTime)
        ),
        insuranceDueTime: Date.parse(
            new Date(this.formInsurance.insuranceDueTime)
        ),
        vehicleId: this.id,
      });
      let data = await this.$axios.post(url, params);
      if (data && data.code === 1) {
        this.$message.success("保存成功！");
        this.insuranceVisible = false;
        this.getInsuranceRows();
      }
      this.loadingInsurance = false;
    },
    /**
     * 接口请求-保险信息编辑
     */
    async putInsurance() {
      this.loadingInsurance = true;
      let url = "/api/v1/manage/vehicle/supervise/insurance";
      let params = this.$utils.deepCopyFn({
        ...this.formInsurance,
        insuranceEffectTime: Date.parse(
            new Date(this.formInsurance.insuranceEffectTime)
        ),
        insuranceDueTime: Date.parse(
            new Date(this.formInsurance.insuranceDueTime)
        ),
        vehicleId: this.id,
      });
      let data = await this.$axios.put(url, params);
      if (data && data.code === 1) {
        this.$message.success("保存成功！");
        this.insuranceVisible = false;
        this.getInsuranceRows();
      }
      this.loadingInsurance = false;
    },
    /**
     * 获取单个车辆详情
     */
    async getInfo() {
      if (!this.id) {
        return false;
      }
      let formIURL = "/api/v1/manage/vehicle/" + this.id;
      let dataI = await this.$axios.get(formIURL);
      if (dataI && dataI.code === 1) {
       
        this.formIIII = {
          id: this.id,
          compulsoryTrafficInsurance: dataI.data.compulsoryTrafficInsurance,
          commercialInsurance: dataI.data.commercialInsurance,
        }
      }

      let formIIURL = "/api/v1/manage/vehicle/supervise/service/" + this.id;
      let dataII = await this.$axios.get(formIIURL);
      if (dataII && dataII.code === 1) {
        this.formII = dataII.data || {};
      }

      let formIIIURL = "/api/v1/manage/vehicle/supervise/other/" + this.id;
      let dataIII = await this.$axios.get(formIIIURL);
      if (dataIII && dataIII.code === 1) {
        this.formIII = dataIII.data || {};
      }
      this.getInsuranceRows();
    },

    //获取保险信息列表
    async getInsuranceRows() {
      let insuranceURL = "/api/v1/manage/vehicle/supervise/insurance";
      let params = {vehicleId: this.id};
      let res = await this.$axios.get(insuranceURL, params);
      if (res && res.code === 1) {
        res.data.forEach((item) => {
          item.insuranceEffectTime = this.$utils.timeFn(
              item.insuranceEffectTime,
              "YYYY/MM/DD"
          );
          item.insuranceDueTime = this.$utils.timeFn(
              item.insuranceDueTime,
              "YYYY/MM/DD"
          );

          item.insuranceTypeName = new Map([
            [1, "交强险"],
            [2, "商业险"],
            [3, "承运人责任险"],
          ]).get(item.insuranceType);
        });
        this.insuranceRows = res.data || [];
      }
    },

    //删除保险信息
    async removeInsurance(row) {
      let insuranceURL = "/api/v1/manage/vehicle/supervise/insurance/" + row.id;
      let res = await this.$axios.delete(insuranceURL);
      if (res && res.code === 1) {
        this.$message.success("已删除");
        this.getInsuranceRows();
      }
    },
    edit(row) {
      this.insuranceVisible = true;
      this.$nextTick(() => {
        this.formInsurance = JSON.parse(JSON.stringify(row));
      });
    },
    
  },
  async created() {
    await this.getInfo();
  },
  watch: {},
};
</script>

<style lang="less">
#vehicleForm {
  width: 1100px;
  padding-left: 40px;

  .first-level {
    display: block;
  }

  .second-level {
    padding-left: 24px;
  }
}</style>
